import React from 'react';

export default function ModalClose(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.5278 2.4722L13.5278 13.4722M2.4722 13.4722L13.4722 2.4722"
        stroke="#1D1919"
        strokeWidth="1.5"
      />
    </svg>
  );
}
